import {
  Box,
  Image,
  Flex,
  Button,
  Tooltip,
  Avatar,
  Text,
  HStack,
} from "@chakra-ui/react";
import { useState } from "react";
import { ReactSVG } from "react-svg";
import like from "@/assets/like.svg";
import collect from "@/assets/collect.svg";
import comment from "@/assets/comment.svg";
import history from "@/assets/content_history.svg";
import onekey from "@/assets/onekey.svg";
import { Content } from "@/types/content";
import {
  RiStarFill,
  RiStarLine,
  RiThumbUpFill,
  RiThumbUpLine,
} from "@remixicon/react";
/**
 * @image 图片url
 * @pageView 浏览量
 * @likeCount 点赞量
 * @collectCount 收藏量
 * @oneClickCount 一键同款量
 */

/**
 * @onClick 图片点击事件
 * @onOneClick 一键同款点击事件
 * @onLike 点赞点击事件
 * @onCollect 收藏点击事件
 */
type Props = {
  content: Content;
  onClick: () => void;
  onOneClick: () => void;
  onLike: () => void;
  onCollect: () => void;
};
/**
 * 作品展示子组件
 * @param props
 * @returns
 */
const ContentUnit = (props: Props) => {
  const [text, setText] = useState<string | number>(props.content?.onekey_nums);
  return (
    <Box
      position="relative"
      width={"100%"}
      height={"auto"}
      _hover={{ "& .overlay": { opacity: 1 } }}
    >
      <Image
        w="100%"
        src={props.content?.image_url}
        alt="Hover Image"
        objectFit="cover"
        cursor={"pointer"}
        onClick={props.onClick}
      />
      <Flex
        className="overlay"
        position="absolute"
        bottom="0"
        left="0"
        right="0"
        maxH={"70%"}
        flexDirection={"column"}
        pl="10px"
        pr="10px"
        bg="linear-gradient(180deg, rgba(142, 148, 169, 0.2) 0%, #27314D 101%)"
        color="white"
        textAlign="center"
        opacity={0}
        transition="opacity 0.3s"
      >
        <Flex justifyContent={"space-between"}>
          <HStack>
            <Avatar src="https://bit.ly/tioluwani-kolawole" w="20px" h="20px" />
            <Text fontSize="12px">
              {props.content?.nickname ?? props.content?.username}
            </Text>
          </HStack>
          <HStack spacing="10px">
            <Flex alignItems="center" cursor={"pointer"} onClick={props.onLike}>
              {/* <ReactSVG src={like} /> */}
              {!props.content.is_like && (
                <RiThumbUpLine size="16px" color="#E6E6E6" />
              )}
              {props.content.is_like && (
                <RiThumbUpFill size="16px" color="#E6E6E6" />
              )}
              <Text color="#E6E6E6" fontSize="10px" ml="5px">
                {props.content.like_num}
              </Text>
            </Flex>
            <Flex
              alignItems="center"
              cursor={"pointer"}
              onClick={props.onCollect}
            >
              {/* <ReactSVG src={collect} /> */}
              {!props.content.is_collect && (
                <RiStarLine size="16px" color="#E6E6E6" />
              )}
              {props.content.is_collect && (
                <RiStarFill size="16px" color="#E6E6E6" />
              )}
              <Text color="#E6E6E6" fontSize="10px" ml="5px">
                {props.content.collect_num}
              </Text>
            </Flex>
            <Flex alignItems="center">
              <ReactSVG src={comment} />
              <Text color="#E6E6E6" fontSize="10px" ml="5px">
                {props.content.comment_num}
              </Text>
            </Flex>
          </HStack>
        </Flex>
        <Box flex={1} h="0" mb="2px" overflowY={"auto"}>
          <Text
            textAlign={"left"}
            fontSize={"12px"}
            mt={"5px"}
            mb={"10px"}
            overflow={"hidden"}
          >
            {props.content.prompt}
          </Text>
        </Box>

        <Flex alignItems={"center"} pb={"10px"} justifyContent="space-between">
          <Flex alignItems="center">
            <ReactSVG src={history} />
            <Text color="#E6E6E6" fontSize="10px" ml="5px">
              {props.content.onekey_nums}
            </Text>
          </Flex>
          <Button
            leftIcon={<ReactSVG src={onekey} />}
            size="xs"
            colorScheme="blue"
            sx={{ transition: "width 0.5s", width: "50px" }}
            _hover={{ width: "calc(100% - 20px)", marginLeft: "10px" }}
            onMouseOver={() => setText("一键同款")}
            onMouseLeave={() => setText(props.content.onekey_nums)}
            onClick={props.onOneClick}
          >
            {" "}
            {text}
          </Button>
        </Flex>
      </Flex>
    </Box>
  );
};

export default ContentUnit;
